import React, { useRef } from "react";
import styled from "@emotion/styled";
import Shared03Divider from "../../../guestsharedcomponents/Shared03Divider/Shared03Divider";

const ContainerDiv = styled.div`
  width: 100%;
  color: #f5e7d3;

  .steps-wrapper {
    display: flex;
    gap: 3.5rem;
    padding: 5rem 0;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
  }

  .steps-wrapper::-webkit-scrollbar {
    display: none;
  }

  .step-card {
    min-width: 85%;
    min-height: 50rem;
    /*   background: linear-gradient(
      180deg,
      rgba(255, 215, 160, 0.08),
      rgba(0, 0, 0, 0.4)
    ); */
    background: url("https://res.cloudinary.com/djiqf3usa/image/upload/v1769457014/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/sensual-bachata-academy-dark-gold-abstract-background.webp_p9noqm.webp");
    border: 1px solid rgba(255, 215, 160, 0.25);
    border-radius: 1.5rem;
    padding: 2rem;
    scroll-snap-align: start;
    position: relative;
    box-shadow: 0 0 40px rgba(255, 180, 90, 0.15);
  }

  .cover {
    background: rgb(0 0 0 / 70%);
    border-radius: 1.5rem;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .step-number {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: radial-gradient(circle, #ffcf8a, #b8772b);
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    margin-bottom: 16px;
    box-shadow: 0 0 16px rgba(255, 200, 120, 0.8);
  }

  .step-title {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
  }

  .step-text {
    font-size: 14px;
    line-height: 1.6;
    opacity: 0.85;
  }

  .step-image {
    position: absolute;
    bottom: -5rem;
    left: 0;
    right: 0;
    width: 103%;
  }

  /* Desktop */
  @media (min-width: 992px) {
    .steps-wrapper {
      justify-content: center;
      overflow: visible;
    }

    .step-card {
      min-width: 32rem;
    }

    .step-card:nth-of-type(1) .step-image {
      left: -65px;
    }

    .step-card:nth-of-type(3) .step-image {
      left: 45px;
    }
  }
`;

const HOW_IT_WORKS_STEPS = [
  {
    id: 1,
    title: "Start at Your Level",
    text: "Find your starting point and begin with confidence. Whether you’re completely new to bachata or already dancing, LT Mastery helps you start at the right level. No partner required, no pressure, just a clear entry point designed to meet you where you are.",
    obj_img: {
      image:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1769455688/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/start-bachata-from-zero-no-partner-required_sxrees.webp",
      alt_image:
        "Starting point inside the LT Mastery academy showing beginner sensual bachata lessons with no partner required",
    },
  },
  {
    id: 2,
    title: "Train With Structure",
    text: "Follow a guided path that builds real skills. Each lesson is part of a bigger system. You’ll train technique, movement, and connection in a logical order. So every class builds on the last and nothing feels random or disconnected.",
    obj_img: {
      image:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1769454674/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/structured-sensual-bachata-training-system-dashboard_d0trnm.webp",
      alt_image:
        "Structured sensual bachata training system inside the LT Mastery dashboard showing guided lessons and clear progression",
    },
  },
  {
    id: 3,
    title: "Progress & Grow",
    text: "See your progress. Feel the difference. As you move through the academy, you’ll unlock new levels, refine your skills, and gain confidence that shows both on and off the dance floor. Progress isn’t rushed, it’s earned and felt over time.",
    obj_img: {
      image:
        "https://res.cloudinary.com/djiqf3usa/image/upload/v1769455553/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/sensual-bachata-progress-tracking-confidence-growth_elafgn.webp",
      alt_image:
        "Progress tracking inside the LT Mastery academy showing growth in sensual bachata skills and confidence over time",
    },
  },
];

const ContainerHowItWorks = () => {
  const wrapperRef = useRef(null);

  return (
    <ContainerDiv className="t-mb-7">
      <div className="steps-wrapper t-pr" ref={wrapperRef}>
        {HOW_IT_WORKS_STEPS.map((info) => (
          <div className="step-card" key={info.id}>
            <div className="cover"></div>
            <div className="step-number t-pr">{info.id}</div>
            <h3 className="step-title t-pr">{info.title}</h3>
            <Shared03Divider
              options={{
                obj_divider: {
                  divider_mobile_styles: {
                    width: "50%",
                    background:
                      "linear-gradient(90deg, #e6c28b, #e6c28b, transparent)",
                    margin: "0 0 2rem 0",
                  },
                  divider_desktop_styles: false,
                },
                style_render: false,
              }}
            />
            <p className="step-text t-mb-3">{info.text}</p>
            <div className="step-image">
              <img
                src={info?.obj_img?.image}
                alt={info?.obj_img?.alt_image}
                loading="lazy"
              />
            </div>
          </div>
        ))}
      </div>
    </ContainerDiv>
  );
};

export default ContainerHowItWorks;
